define([
    'handlebars',
    'modules/common/controls/select2',
    'appcontext',
    'enums'
], (Handlebars, Select2, appContext, enums) => {

    function getPlacementType (state) {
        const placementType = state.placement_type;
        if (placementType) {
            return '[{0}]'.format(enums.placementTypes.get(placementType).get('name'));
        }
        return '';
    }

    function formatState (state, muteInactive) {
        const html = '{0} #{1} {2} {3}'.format(
            Handlebars.helpers.h_channel_img(state.channel_id), state.id, _.escape(state.name), getPlacementType(state)
        );
        return state.is_connection_active || !muteInactive ? html : '<span class="muted">{0}</span>'.format(html);
    }

    return Select2.extend({

        formatSelection (state) {
            return formatState(state, this.options.muteInactive);
        },

        formatResult (state) {
            return formatState(state, this.options.muteInactive);
        },

        matcher (term, text, option) {
            let pattern = term.toUpperCase();
            const channel = appContext.channels().get(option.channel_id);
            const channelName = channel ? channel.get('name') : null;
            const labelPrefixUpper = 'LABEL:';

            /*
             * Match by placement label.
             * label:awesome — match labels which contain 'a', 'aw', 'awe', etc.
             * label:"awesome shmosome" — match label that is equal to 'awesome shmosome' (case insensitive)
             */
            if (pattern.indexOf(labelPrefixUpper) >= 0) {
                const strictMatch = pattern.match(/"(.*?)"/);

                pattern = pattern.replace(labelPrefixUpper, '').replace(/"/g, '');
                return _.some(option.labels, (label) => {
                    const labelUpper = label.toUpperCase();
                    return strictMatch ? labelUpper === strictMatch[1] : labelUpper.indexOf(pattern) >= 0;
                });
            }

            return option.name.toUpperCase().indexOf(pattern) >= 0 ||
                String(option.id).indexOf(term) >= 0 ||
                (channelName ? channelName.toUpperCase().indexOf(pattern) >= 0 : false) ||
                (option.campaign_xid ? option.campaign_xid.toUpperCase().indexOf(pattern) >= 0 : false);
        }

    });

});
